import { getApiUrl, getAxiosInstanceByLoginMode } from './shared';

const getPriceReasonCodes = () => {
  return getAxiosInstanceByLoginMode().get(
    `${getApiUrl()}/appcodes?languageCode=${navigator.language}&type=PRICE_REASON_CODES`
  );
};

export { getPriceReasonCodes };
